import React, { FC } from 'react';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';

import { spaceTopCompact } from '@/styles';
import { DAC_DOCS_BASE_URL } from '@/constants';

import { testIds } from './constants';

type UnassignedWarningMessageProps = {
  onAssignClick: () => void;
};

const UnassignedWarningMessage: FC<UnassignedWarningMessageProps> = ({ onAssignClick }) => (
  <div css={spaceTopCompact}>
    <SectionMessage
      testId={testIds.unassignedMessage}
      title="This team isn't associated with any Atlassian Organisation"
      appearance="warning"
      actions={[
        <SectionMessageAction
          testId={testIds.buttonAssign}
          key="button-assign"
          onClick={onAssignClick}
        >
          Assign team to an Atlassian Organisation
        </SectionMessageAction>,
        <SectionMessageAction
          key="button-see-our-docs"
          href={`${DAC_DOCS_BASE_URL}teams/#connecting-an-atlassian-org-team-to-a-tome-team`}
        >
          See our docs
        </SectionMessageAction>,
      ]}
    >
      <></>
    </SectionMessage>
  </div>
);

export default UnassignedWarningMessage;
